<template>
  <div class="columns">
    <div class="column is-one-quarter  cfholder">

        <clientfilter></clientfilter>

    </div>
    <div class="column">
      <div class="columns is-multiline is-gapless is-mobile clientcontainer" @mouseleave="boxOff">
        <div class="column is-narrow" v-for="(client,index) in this.clients">
          
          <div class="client" :class="{dev: client.dev, seo: client.seo, code: client.code, design: client.design, agency: client.agency }" @mouseover="boxHover" @click="boxClick" >
            
              <img :src="'./static/clients/' + client.logo" :alt="client.name" />
            
            <div class="details"><b>{{ client.name }}</b><br />{{ client.description }}</div>
          </div>
        </div>
        <!-- <div class="column">&nbsp;</div>
        <div class="column">&nbsp;</div>
        <div class="column">&nbsp;</div>
        <div class="column">&nbsp;</div>
        <div class="column">&nbsp;</div> -->
      </div>

    </div>
  </div>
</template>

<style lang="scss" scoped>
.cfholder {
  position:relative;
}
.client.hide {
  filter:opacity(20%);
  box-shadow:0px 0px rgba(black,0.2);
  pointer-events:none;
  &.active {
    opacity:0;
    .details {
      top:120px;
    }
  }
 }
.is-touch .client img {
  filter:none;
}
.is-multiline {
  max-width:100vw;
  overflow:hidden;
}
.client {
  cursor:pointer;
  position: relative;
  overflow:hidden;
  display:flex;
  justify-content: center;
  align-items:center;
  background-color:#fff;
  height:120px;
  width:120px;
  max-width: 25vw;
  max-height: 25vw;
  padding:10px;
  transform:scale(0.8);
  
    img {
      max-height: 100px;
      filter: saturate(25%);
      pointer-events:none;
    }
  
  opacity:0.9;
  box-shadow:8px 8px rgba(black, 0.2);
  &.active img {
    opacity:1;
    filter: saturate(100%);
  }
  &.open {
    .details {
      top:0px;
    }
  }
  transition: all 0.25s ease-out;
  .details {
    position:absolute;
    width:100%;
    height:100%;
    top:140px;
    left:0px;
    padding:10px;
    background: #0099cc;
    font-size:12px;
    // background: linear-gradient(to top, #00bf8f , #001510);
    color:#fff;
    z-index:5;
    transition:all 0.2s ease-in-out;
    pointer-events:none;
  }
}
.client.inview {
  opacity:1;
}
@media (Max-width: 800px) {
  .clientcontainer {
    justify-content: center;
  }
}
</style>
<script>
import clientfilter from './clientfilter'

export default {
  name: 'clientlist',
  props: ['index', 'name', 'logo', 'services'],
  components: {
    clientfilter
  },
  methods: {
    resetBoxes: function () {
      if (!this.isMobile) {
        let boxes = document.querySelectorAll(".bmv-reflective .client")
        Array.prototype.forEach.call(boxes,function(el, i) {
          let rect = el.getBoundingClientRect()
          let x = (rect.left + document.body.scrollLeft) + (el.offsetWidth / 2)
          let y = (rect.top + document.body.scrollTop) + (el.offsetHeight / 2)
          el.setAttribute('data-x',x)
          el.setAttribute('data-y',y)
        })
      }
    },
    boxClick: function (event) {
      let boxes = document.querySelectorAll(".client")
      Array.prototype.forEach.call(boxes,function(el, i) {
        el.classList.remove('open')
      })
      event.target.classList.toggle('open')
    },
    boxHover: function (event) {
      if (!this.isMobile) {
      // Hide active boxes first
        let oldboxes = document.querySelectorAll(".client.active")
        Array.prototype.forEach.call(oldboxes,function(el, i) {
          el.classList.remove('active')
          el.classList.remove('open')
        })
        event.target.classList.add('active')
        var boxes = document.querySelectorAll(".bmv-reflective .client")
        Array.prototype.forEach.call(boxes,function(el, i) {
          var doppelgangers = document.querySelectorAll(".bmv-reflection .client")
          let activebox = document.querySelector(".client.active")
          let difx = el.getAttribute('data-x') - activebox.getAttribute('data-x')
          let dify = el.getAttribute('data-y') - activebox.getAttribute('data-y')
          let dif = Math.sqrt(difx * difx + dify * dify)
          let amp = 20 - (dif / 50)
          var mycss = ''
          if (dif === 0) {
            doppelgangers[i].classList.add('active')
            mycss = 'perspective(100px) rotateX(0deg) rotateY(0deg) scale(1)'
          } else {
            mycss = 'perspective(100px) rotateX(' + Math.round((dify / dif) * amp) + 'deg) rotateY(' + (0 - Math.round((difx / dif) * amp)) + 'deg) scale(0.8)'
          }
          el.style.transform = mycss
          doppelgangers[i].style.transform = mycss
        })
      }
    },
    boxOff: function (event) {
      if (!this.isMobile) {
        event.target.classList.remove('active')
        event.target.classList.remove('open')
        let boxes = document.querySelectorAll(".client")
        Array.prototype.forEach.call(boxes,function(el, i) {
          el.style.transform = "perspective(100px) rotateX(0deg) rotateY(0deg) scale(0.8)"
          el.classList.remove('active')
          el.classList.remove('open')
        })
      }
    },
    loadedClient: function (event) {
      requestAnimationFrame(function() {
        let mirror = document.querySelector('.bmv-reflection .clients div[data-n="'+event.$el.getAttribute('data-n')+'"]')
        if (mirror) {
          mirror.innerHTML = event.$el.innerHTML
        }
      })
    },
    reflectThis() {
      document.querySelector(".bmv-reflection .clients").innerHTML = document.querySelector(".bmv-reflective .clients").innerHTML
      this.resetBoxes()
    },
    sortByProperty: function (p) {
      return function(a,b) {
        // var sortStatus = 0
        // if (a[p] < b[p]) {
        //   sortStatus = -1
        // } else if (b[p] > a[p]) {
        //   sortStatus = 1
        // }
        // return sortStatus
        return a[p].localeCompare(b[p])
      }
    }
    // sortByName(a,b) {
    //   if (a.name < b.name)
    //     return -1
    //   if (a.name > b.name)
    //     return 1
    //   return 0
    // }
  },
  mounted () {
    let isMobileD = {
      android: () => navigator.userAgent.match(/Android/i),
      blackberry: () => navigator.userAgent.match(/BlackBerry/i),
      ios: () => navigator.userAgent.match(/iPhone|iPad|iPod/i),
      opera: () => navigator.userAgent.match(/Opera Mini/i),
      windows: () => navigator.userAgent.match(/IEMobile/i),
      any: () => (isMobileD.android() || isMobileD.blackberry() || 
      isMobileD.ios() || isMobileD.opera() || isMobileD.windows())
    }
    this.isMobile = isMobileD.any()
    // this.clients.sort(sortByName)
    window.addEventListener('resize',this.resetBoxes, false)
    // var self = this
    // this.$http.get('./static/clients-sm.json').then(response => {
    //   this.clients = response.body
    //   this.clients.sort(this.sortByProperty('name'))
    //   console.log(JSON.stringify(this.clients))
    //   setTimeout(()=> { this.reflectThis() },100)
    // }, response => {
    //   console.log(err)
    // })
    this.resetBoxes()

  },
    data: function () {
    return {
      isMobile: false,
    clients: [  {
              "logo": "a8.jpg",
              "dev": false,
              "agency": false,
              "seo": true,
              "code": true,
              "design": false,
              "description": "Search Engine Optimization",
              "name": "Analytics8"
            },
            {
              "logo": "azar.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": false,
              "description": "Web Development",
              "name": "Azar Nut Company"
            },
            {
              "logo": "bvf.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": false,
              "description": "Web Development",
              "name": "Bay Valley Foods"
            },
            {
              "logo": "bosch.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": false,
              "description": "Microsite Development",
              "name": "Bosch"
            },
            {
              "logo": "carcollection.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": true,
              "description": "Web Design & Development",
              "name": "Car Collection"
            },
            {
              "logo": "pro.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": true,
              "description": "Web Design & Development",
              "name": "Chicago Pro Speakers"
            },
            {
              "logo": "csn.jpg",
              "dev": true,
              "agency": false,
              "seo": true,
              "code": true,
              "design": true,
              "description": "SEO, Web Design, Development & Micro-site Development",
              "name": "Corporate Suites Network"
            },
            {
              "logo": "cssi.jpg",
              "dev": false,
              "agency": true,
              "seo": false,
              "code": false,
              "design": false,
              "description": "Partner Agency",
              "name": "CSSI Marketing + Culinary"
            },
            {
              "logo": "cw.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": true,
              "design": true,
              "description": "CFO Roundtable Web Design & Development",
              "name": "CW CFO Roundtable"
            },
            {
              "logo": "degerberg.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": true,
              "description": "Web Design & Development",
              "name": "Degerberg"
            },
            {
              "logo": "diamond.jpg",
              "dev": false,
              "agency": false,
              "seo": true,
              "code": false,
              "design": false,
              "description": "Search Engine Optimization",
              "name": "Diamond Marketing Solutions"
            },
            {
              "logo": "directions.jpg",
              "dev": false,
              "agency": false,
              "seo": true,
              "code": false,
              "design": false,
              "description": "Search Engine Optimization",
              "name": "Directions Training"
            },
            {
              "logo": "fitlp.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": true,
              "description": "Web Design & Development",
              "name": "FIT Lincoln Park"
            },
            {
              "logo": "goodcheap.jpg",
              "dev": true,
              "agency": true,
              "seo": false,
              "code": false,
              "design": false,
              "description": "Web Development",
              "name": "Good Cheap Video"
            },
            {
              "logo": "grubhub.jpg",
              "dev": false,
              "agency": false,
              "seo": false,
              "code": true,
              "design": true,
              "description": "Banner Ad Development",
              "name": "GrubHub"
            },
            {
              "logo": "hard.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": true,
              "design": false,
              "description": "Website Development",
              "name": "Hard Pressed"
            },
            {
              "logo": "hozell.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": true,
              "description": "Web Design & Development",
              "name": "Hozell"
            },
            {
              "logo": "ia.jpg",
              "dev": true,
              "agency": true,
              "seo": false,
              "code": false,
              "design": false,
              "description": "Website Development",
              "name": "IA Collaborative"
            },
            {
              "logo": "IMedge.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": true,
              "description": "Web Design & Development",
              "name": "IM edge"
            },
            {
              "logo": "jacobs.jpg",
              "dev": false,
              "agency": true,
              "seo": true,
              "code": false,
              "design": false,
              "description": "Search Engine Optimization",
              "name": "Jacobs Agency"
            },
            {
              "logo": "jet.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": true,
              "description": "Web Design & Development",
              "name": "Jet Collection"
            },
            {
              "logo": "jones.jpg",
              "dev": false,
              "agency": false,
              "seo": true,
              "code": false,
              "design": false,
              "description": "Search Engine Optimization",
              "name": "Jones Dairy Farm"
            },
            {
              "logo": "kd.jpg",
              "dev": false,
              "agency": false,
              "seo": false,
              "code": true,
              "design": false,
              "description": "Custom Programming",
              "name": "KD Mailing"
            },
            {
              "logo": "KillerSpin.jpg",
              "dev": false,
              "agency": false,
              "seo": true,
              "code": false,
              "design": false,
              "description": "Search Engine Optimization",
              "name": "Killerspin"
            },
            {
              "logo": "kingsbury.jpg",
              "dev": false,
              "agency": false,
              "seo": true,
              "code": true,
              "design": false,
              "description": "SEO & Custom Programming",
              "name": "Kingsbury Plaza"
            },
            {
              "logo": "ksn.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": true,
              "description": "Web Development",
              "name": "Kovitz Shifrin Nesbit"
            },
            {
              "logo": "lpm.jpg",
              "dev": true,
              "agency": true,
              "seo": false,
              "code": true,
              "design": true,
              "description": "Web Development",
              "name": "Lisa P. Maxwell"
            },
            {
              "logo": "lurie.jpg",
              "dev": false,
              "agency": false,
              "seo": true,
              "code": false,
              "design": false,
              "description": "Search Engine Optimization",
              "name": "Lurie Children's Hospital"
            },
            {
              "logo": "mccanns.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": false,
              "description": "Search Engine Optimization",
              "name": "McCann's Irish Oatmeal"
            },
            {
              "logo": "mcdevitt.jpg",
              "dev": true,
              "agency": false,
              "seo": true,
              "code": false,
              "design": true,
              "description": "Web Development & SEO",
              "name": "McDevitt"
            },
            {
              "logo": "mcdh.jpg",
              "dev": false,
              "agency": false,
              "seo": true,
              "code": false,
              "design": false,
              "description": "Search Engine Optimization",
              "name": "McDonald Hopkins"
            },
            {
              "logo": "mhdesign.jpg",
              "dev": true,
              "agency": true,
              "seo": false,
              "code": false,
              "design": false,
              "description": "Web Development",
              "name": "Mike Hough Design"
            },
            {
              "logo": "namewell.jpg",
              "dev": false,
              "agency": true,
              "seo": true,
              "code": false,
              "design": false,
              "description": "Search Engine Optimization",
              "name": "Namewell"
            },
            {
              "logo": "natures.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": true,
              "description": "Web Development",
              "name": "Nature's Own Water Care"
            },
            {
              "logo": "norkol.jpg",
              "dev": true,
              "agency": false,
              "seo": true,
              "code": false,
              "design": true,
              "description": "Web Design, Development & SEO",
              "name": "Norkol"
            },
            {
              "logo": "prf.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": false,
              "description": "Web Development",
              "name": "Paul Ruby Foundation"
            },
            {
              "logo": "phillips.jpg",
              "dev": true,
              "agency": false,
              "seo": true,
              "code": false,
              "design": true,
              "description": "Web Design, Development, & SEO",
              "name": "Phillips Martin"
            },
            {
              "logo": "powerplanter.jpg",
              "dev": false,
              "agency": false,
              "seo": false,
              "code": true,
              "design": false,
              "description": "Programming",
              "name": "Power Planter"
            },
            {
              "logo": "primo.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": false,
              "description": "Web Development",
              "name": "Primo Tees"
            },
            {
              "logo": "pug.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": true,
              "description": "Web Design & Development",
              "name": "Pug Story"
            },
            {
              "logo": "redmoby.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": true,
              "description": "Web Development",
              "name": "Red Moby"
            },
            {
              "logo": "reina.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": true,
              "design": false,
              "description": "Web Development & Custom Programming",
              "name": "Reina Imaging"
            },
            {
              "logo": "rightpoint.jpg",
              "dev": false,
              "agency": true,
              "seo": true,
              "code": false,
              "design": false,
              "description": "Search Engine Optimization",
              "name": "Rightpoint"
            },
            {
              "logo": "rsi.jpg",
              "dev": false,
              "agency": false,
              "seo": true,
              "code": false,
              "design": false,
              "description": "Search Engine Optimization",
              "name": "RSi"
            },
            {
              "logo": "sacp.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": true,
              "description": "Web Design & Development",
              "name": "Send a care package"
            },
            {
              "logo": "situ8.jpg",
              "dev": false,
              "agency": true,
              "seo": true,
              "code": true,
              "design": false,
              "description": "SEO & Site Re-development",
              "name": "Situ8"
            },
            {
              "logo": "stitchtopia.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": false,
              "description": "Web Development",
              "name": "Stitchtopia"
            },
            {
              "logo": "strongsuit.jpg",
              "dev": true,
              "agency": false,
              "seo": true,
              "code": false,
              "design": true,
              "description": "Web Design, Development, & SEO",
              "name": "Strongsuit"
            },
            {
              "logo": "techimage.jpg",
              "dev": true,
              "agency": false,
              "seo": true,
              "code": true,
              "design": true,
              "description": "Web Design, Development & SEO",
              "name": "Tech Image"
            },
            {
              "logo": "habitat.jpg",
              "dev": true,
              "agency": false,
              "seo": true,
              "code": true,
              "design": true,
              "description": "Microsite Design, Development & SEO",
              "name": "The Habitat Company"
            },
            {
              "logo": "iroquois.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": true,
              "description": "Web Design & Development",
              "name": "The Iroquois Club"
            },
            {
              "logo": "topdriver.jpg",
              "dev": false,
              "agency": false,
              "seo": true,
              "code": false,
              "design": false,
              "description": "Search Engine Optimization",
              "name": "Top Driver"
            },
            {
              "logo": "trifecta.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": false,
              "description": "Web Development",
              "name": "Trifecta"
            },
            {
              "logo": "vi.jpg",
              "dev": false,
              "agency": false,
              "seo": true,
              "code": false,
              "design": false,
              "description": "Search Engine Optimization",
              "name": "Vi"
            },
            {
              "logo": "wlf.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": false,
              "description": "Search Engine Optimization",
              "name": "West Liberty Foods"
            },
            {
              "logo": "wholesalep.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": true,
              "description": "Web Design & Development",
              "name": "Wholesale Point"
            },
            {
              "logo": "wrapz.jpg",
              "dev": false,
              "agency": false,
              "seo": false,
              "code": false,
              "design": false,
              "description": "Web Updates",
              "name": "Wrapz"
            },
            {
              "logo": "york.jpg",
              "dev": true,
              "agency": false,
              "seo": true,
              "code": false,
              "design": true,
              "description": "Web Design, Development & SEO",
              "name": "York Terrace"
            },
            {
              "logo": "young.jpg",
              "dev": true,
              "agency": false,
              "seo": false,
              "code": false,
              "design": false,
              "description": "Web Development",
              "name": "Young Center"
            },
            {
              "logo": "zimmer.jpg",
              "dev": true,
              "agency": true,
              "seo": false,
              "code": false,
              "design": false,
              "description": "Web Development",
              "name": "Zimmer Design"
            }
          ]

    }
  }
}

</script>



// WEBPACK FOOTER //
// Client.vue?3c4e5696